import React from 'react';
import { Link } from '../../atoms/Link';
import './MainNavMobileItem.css';

export interface MainNavMobileItemProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  href?: string;
  active?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const MainNavMobileItem: React.FC<MainNavMobileItemProps> = ({
  icon,
  label,
  onClick,
  href,
  active = false,
  className = '',
  style,
}) => {
  const content = <div className="hi-ui-mainnav-mobile-item__icon">{icon}</div>;

  // If onClick is provided, render as button
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`hi-ui hi-ui-mainnav-mobile-item ${active ? 'active' : ''} ${className}`.trim()}
        style={style}
        aria-label={label}
      >
        {content}
      </button>
    );
  }

  // Otherwise, render as link
  return (
    <Link
      href={href || '#'}
      noUnderline
      className={`hi-ui hi-ui-mainnav-mobile-item ${active ? 'active' : ''} ${className}`.trim()}
      style={style}
      aria-label={label}
    >
      {content}
    </Link>
  );
};
